import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Typography,
  Box,
  Button,
  useMediaQuery,
  IconButton,
  ListItemButton,
  List,
  ListItemText,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import joinBGRight from "../images/join-bg-right.jpg";
import targetImage from "../images/home_bg.jpg";
import caseStudiesBg from "../images/case_studies_bg.jpg";
import { Assignment } from "@mui/icons-material";
import EmailSignupModal from "./EmailSignupModal";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import logo512 from "../images/markLogo.jpg";
import XIcon from "@mui/icons-material/X";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    padding: theme.spacing(8, 2),
    textAlign: "center",
  },
  testimonialSection: {
    padding: theme.spacing(8, 0),
    textAlign: "center",
  },
  testimonial: {
    padding: theme.spacing(2),
    position: "relative",
    "&:before": {
      content: '"\\201c"',
      fontFamily: '"Times New Roman", Times, serif',
      display: "block",
      fontSize: "72px",
      lineHeight: "50px",
      fontWeight: 700,
      textAlign: "left",
      position: "static",
      color: "#FFFFFF",
    },
  },
  servicesSection: {
    textAlign: "center",
  },
  caseStudiesSection: {
    backgroundImage: `url(${caseStudiesBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    padding: theme.spacing(8, 2),
    textAlign: "left",
  },
}));

const Home = () => {
  const [showDonate, setShowDonate] = useState(false);
  const location = useLocation();
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isPrioritiesPage = location.pathname === "/priorities";
  const [emailOpen, setEmailOpen] = useState(false);
  const isHomePage = location.pathname === "/";

  // useEffect(() => {
  //   if (isHomePage) {
  //     const hasSeenPopup = localStorage.getItem("emailPopupSeen");

  //     if (!hasSeenPopup) {
  //       setTimeout(() => {
  //         setEmailOpen(true);
  //         localStorage.setItem("emailPopupSeen", "true");
  //       }, 2500); // load delay
  //     }
  //   }
  // }, [isHomePage]);

  useEffect(() => {
    if (isMobile) {
      setShowDonate(true);
    } else {
      const handleScroll = () => {
        setShowDonate(window.scrollY > 100);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [isMobile]);

  return (
    <Box sx={{ backgroundColor: "#106cb7!important" }}>
      <Box
        className={classes.header}
        sx={{
          backgroundImage: isPrioritiesPage
            ? "none"
            : `radial-gradient(circle at 78% 30%, rgba(0, 55, 75, 0) 0%, #02449be6 100%), url(${targetImage})`,
          backgroundColor: isPrioritiesPage ? "#0073e6" : "transparent",
          backgroundSize: "cover",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
          height: isPrioritiesPage ? "200px" : isMobile ? "auto" : "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: isPrioritiesPage ? "2rem" : "8rem",
          textAlign: "center",
        }}
      >
        {isMobile && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              position: "relative",
              top: "2rem",
              marginTop: "10rem",
            }}
          >
            <img
              src={logo512}
              alt="Mark Brewster Logo"
              style={{
                borderRadius: ".5rem",
                boxShadow:
                  "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
              }}
            />
          </Box>
        )}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100vh",
            width: "50vw",
            zIndex: 10,
            textAlign: "center",
            color: "white",
            display: isMobile ? "none" : "auto",
            px: 2,
          }}
        >
          {" "}
          {/* Top Tagline */}{" "}
          <Typography
            sx={{
              fontWeight: 700,
              lineHeight: 1.2,
              fontSize: { xs: "2.5rem", sm: "3.5rem" },
            }}
          >
            {" "}
            Support{" "}
          </Typography>
          {/* Main Headline */}{" "}
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "2.5rem", sm: "3.5rem" },
              lineHeight: 1.1,
              maxWidth: "90vw",
              mb: 3,
            }}
          >
            {" "}
            Mark Brewster<br></br> for County Council{" "}
          </Typography>
          <form
            action="https://api.web3forms.com/submit"
            method="POST"
            style={{ width: "100%" }}
          >
            {" "}
            <input
              type="hidden"
              name="access_key"
              value="f17cc4e5-e9b2-460c-8b30-495af7bd8830"
            />
            <Grid container spacing={1} justifyContent="center" mb={1}>
              {" "}
              <Grid item>
                {" "}
                <TextField
                  variant="filled"
                  placeholder="Email Address"
                  name="email"
                  type="email"
                  required
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 300,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />{" "}
              </Grid>{" "}
              <Grid item>
                {" "}
                <TextField
                  variant="filled"
                  placeholder="Zip"
                  name="zip"
                  required
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 200,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />{" "}
              </Grid>{" "}
            </Grid>
            <Grid container spacing={1} justifyContent="center">
              {" "}
              <Grid item>
                {" "}
                <TextField
                  variant="filled"
                  placeholder="Phone Number"
                  name="phone"
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    width: 300,
                    height: 56,
                    input: { padding: "16px" },
                    "& .MuiFilledInput-root": { borderRadius: 0 },
                  }}
                />{" "}
              </Grid>{" "}
              <Grid item>
                {" "}
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    height: 56,
                    backgroundColor: "#2d7ebf",
                    borderRadius: 0,
                    width: 200,
                    px: 4,
                    fontWeight: "bold",
                    fontSize: "1rem",
                    "&:hover": { backgroundColor: "#cc8500" },
                  }}
                >
                  {" "}
                  JOIN{" "}
                </Button>{" "}
              </Grid>{" "}
            </Grid>
          </form>
          {/* Disclaimer */}{" "}
          <Typography
            variant="caption"
            sx={{ maxWidth: 500, opacity: 0.7, mt: 2, fontSize: "0.75rem" }}
          >
            {" "}
            By providing your cell phone number you consent to receive recurring
            donation & campaign updates.{" "}
          </Typography>{" "}
        </Grid>

        <Grid container justifyContent="center">
          <Typography
            variant="h2"
            sx={{
              color: "#FFFFFF",
              fontSize: isPrioritiesPage ? "2.5rem" : "4rem",
              fontWeight: 700,
            }}
          >
            {isPrioritiesPage ? "Priorities" : ""}
          </Typography>
        </Grid>
      </Box>

      {/* MEET MARK Section */}
      <Grid
        id="meet-mark"
        container
        display="flex"
        justifyContent="center"
        px={6}
        py={12}
        flexDirection="column"
        sx={{
          background: `#02449b!important`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: isMobile ? "2rem 0" : "6rem 3rem",
          borderTop: "1px solid #ffffff",
          borderBottom: "1px solid #ffffff",
          color: "#fff",
        }}
        alignItems="center"
      >
        {showDonate && (
          <Grid className="donate-top">
            <List>
              <ListItemButton
                component="a"
                href="https://secure.ngpvan.com/beSGPrpSQ06bfZh72prCqw2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItemText primary="DONATE" />
              </ListItemButton>
            </List>
          </Grid>
        )}

        {/* Mark Description */}
        <Grid container display="flex" flexDirection="row">
          <Grid container md={12}>
            <Grid item lg={2} />
            <Grid
              item
              display="flex"
              flexDirection="column"
              justifyContent="center"
              lg={8}
              px={4}
              sx={{
                fontStyle: "normal",
                fontWeight: "500",
                maxWidth: !isMobile ? "50vw" : "auto",
                fontSize: "1.25rem",
                lineHeight: "1.6875",
                fontFamily: "'Open Sans', sans-serif",
                letterSpacing: "0em",
                textAlign: "left",
                color: "#FFFFFF",
                mb: 2,
              }}
            >
              <Typography variant="p">
                Mark is a lifelong Owings Mills resident, dedicated public
                servant, and experienced local government professional running
                for Baltimore County Council. As an analyst with the Baltimore
                County Department of Health and Human Services, Mark works every
                day to make government more efficient and ensure residents
                receive the services they need. <br></br>
                <br></br>With deep roots in our community and a strong track
                record of results in county government, Mark is ready to bring
                bold, effective, and people-first leadership to the Council.
                He’s running to fight for affordable housing, better
                transportation, safer neighborhoods, and a stronger, more
                transparent county government that works for everyone.<br></br>
                <br></br>
                With dysfunction coming from Washington, D.C., Mark knows that
                local government must be the anchor that holds our communities
                together, and he has the skills to ensure that it does.
              </Typography>
            </Grid>
            <Grid item lg={2} />
          </Grid>
        </Grid>
      </Grid>

      {/* Volunteer Section */}
      <Grid
        container
        flexDirection="row"
        sx={{ background: "#2d7ebf!important" }}
      >
        <Grid
          id="learn-more-deb"
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{ minHeight: "300px" }}
          md={12}
        >
          <Grid item sx={volunteerHeaderStyle(isMobile)}>
            <Typography
              variant="h3"
              sx={{ color: "#FFF!important", fontWeight: "bold!important" }}
            >
              Join Mark's Team
            </Typography>
          </Grid>

          <Grid item sx={volunteerButtonStyle(isMobile)}>
            <Button
              startIcon={
                <Assignment
                  sx={{ fontSize: "5rem!important", color: "white" }}
                />
              }
              sx={{
                padding: "1rem 2rem",
                color: "white!important",
                background: "#02449b!important",
                border: "1px solid white",
                boxShadow:
                  "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
              }}
              href="https://docs.google.com/forms/d/e/1FAIpQLScPgCTNLNrh_6SHIDXPnY8TlZszp8V3Bg1iY2ITJm8C5_Y_bg/viewform"
              target="_blank"
            >
              <Typography variant="h3" sx={{ color: "white!important" }}>
                Volunteer Today!
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          pb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setEmailOpen(true)}
              sx={{
                textTransform: "none",
                background: "#FFFFFF!important",
                color: "#2d7ebf!important",
              }}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://www.instagram.com/mark.brewster_/profilecard/?igsh=MWVrMDN0eWlzY3E0cQ==/mark_brewster"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            {/* <IconButton
              component="a"
              href="https://x.com/Mark_Brewster"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon sx={{ color: "white" }} />
            </IconButton> */}
            <IconButton
              component="a"
              href="https://facebook.com/profile.php?id=61577947200300"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid item sx={{ px: 1 }}>
            <Typography
              variant="h6"
              sx={{
                border: "1px solid white",
                padding: ".1rem .5rem !important",
                borderRadius: ".25rem!important",
                color: "white",
                fontSize: "1rem!important",
                margin: "1rem",
              }}
            >
              By authority: Friends of Mark Brewster; Juna Goldstein, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};

const volunteerHeaderStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  fontSize: "16px",
  lineHeight: "1.6875",
  fontFamily: "'Open Sans', sans-serif",
  textAlign: "center",
  color: "#106cb7!important",
  mt: 2,
  mb: 4,
  px: 2,
});

const volunteerButtonStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  mt: 2,
  mb: 2,
  px: 2,
});

const volunteerFooterStyle = (isMobile) => ({
  fontWeight: "500",
  maxWidth: isMobile ? "auto" : "50vw",
  mt: 2,
  mb: 2,
  px: 2,
  fontSize: "8px",
  lineHeight: "1.6875",
  textAlign: "center",
  border: "1px solid #106cb7!important",
  borderRadius: ".25rem",
  color: "#106cb7!important",
});

export default Home;
